import React from "react";
import { FastField, Field } from "formik";
import { TextField } from "../../formik-material-ui";

export default function FTextField({ fast, ...other }) {
  const allProps = {
    component: TextField,
    margin: "normal",
    variant: "outlined",
    fullWidth: true,
    ...other,
  };

  if (fast !== false) {
    return <FastField {...allProps} />;
  }
  return <Field {...allProps} />;
}
